import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //仓储费配置-获取计费类型列表
  getFeeTypes: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.getFeeTypes', data),
  //仓储费配置-获取客户等级列表
  getClientLevels: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.getClientLevels', data),
  //仓储费配置-试算仓储费
  calculateFee: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.calculateFee', data),
  //仓储费配置-新增
  storageFeeConfigStore: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.store', data),
  //仓储费配置-更新
  storageFeeConfigUpdate: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.update', data),
  //仓储费配置-列表
  storageFeeConfigList: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.list', data),
  //仓储费配置-详情
  storageFeeConfigDetail: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.detail', data),
  //仓储费配置-删除
  storageFeeConfigDelete: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.delete', data),
  //仓储费配置-复制
  storageFeeConfigCopy: (data) => apiAxios('post', baseURL + '/wms.storageFeeConfig.copy', data),

  //仓储费账单-列表
  wmsStorageBillList: (data) => apiAxios('post', baseURL + '/wms.storageBill.list', data),
  //仓储费账单-详情
  wmsStorageBillDetail: (data) => apiAxios('post', baseURL + '/wms.storageBill.detail', data),


  // 客户仓储收费配置-获取计费类型列表
  storageFeeClientConfigGetFeeTypes: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.getFeeTypes', data),
  // 客户仓储收费配置-获取客户等级列表
  storageFeeClientConfigGetClientLevels: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.getClientLevels', data),
  // 客户仓储收费配置-试算仓储费
  storageFeeClientConfigCalculateFee: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.calculateFee', data),
  // 客户仓储收费配置-新增
  storageFeeClientConfigStore: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.store', data),
  // 客户仓储收费配置-更新
  storageFeeClientConfigUpdate: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.update', data),
  // 客户仓储收费配置-列表
  storageFeeClientConfigList: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.list', data),
  // 客户仓储收费配置-详情
  storageFeeClientConfigDetail: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.detail', data),
  // 客户仓储收费配置-删除
  storageFeeClientConfigDelete: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.delete', data),
  // 客户仓储收费配置-复制
  storageFeeClientConfigCopy: (data) => apiAxios('post', baseURL + '/wms.storageFeeClientConfig.copy', data),

  // 常规仓库账单-列表
  regularStorageBillList: (data) => apiAxios('post', baseURL + '/wms.storageBill.list', data),
  // 常规仓库账单-详情
  regularStorageBillDetail: (data) => apiAxios('post', baseURL + '/wms.storageBill.detail', data),

}
